import { apiProxyRequest as request } from "Api/apiProxyRequest";

import {
  OrderAuthentication,
  OrderAuthenticationError
} from "./OrderAuthentication.types";

export const getOrderAuthentication = async ({
  organizationId,
  orderId
}: {
  organizationId: string;
  orderId: string;
}) =>
  await request<OrderAuthentication | OrderAuthenticationError>(
    `/organizations/${organizationId}/orders/${orderId}/authorize`,
    "POST"
  );
